import layer from './layer';

export const isJotformer = user => ['ADMIN', 'SUPPORT', 'INTERN'].indexOf(user?.account_type?.name) > -1;

export const isMobileApp = () => window.navigator.userAgent.indexOf('JotForm Mobile') > -1 || window.navigator.userAgent.indexOf('JFCEMobile') > -1;

export const isEnvProd = () => window.__jfrouter?.JOTFORM_ENV === 'PRODUCTION' || window.JOTFORM_ENV === 'PRODUCTION';

export const getTestStartDate = ({ testName }) => layer.get(`abtest/test/${testName}/start-date`);
